var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "-0.5 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M9.827 24c0-1.524.253-2.986.705-4.356l-7.909-6.04A23.46 23.46 0 0 0 .213 24c0 3.737.868 7.26 2.407 10.388l7.905-6.05A13.9 13.9 0 0 1 9.827 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M23.714 10.133c3.311 0 6.302 1.174 8.652 3.094L39.202 6.4C35.036 2.773 29.695.533 23.714.533a23.43 23.43 0 0 0-21.09 13.071l7.908 6.04a13.85 13.85 0 0 1 13.182-9.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M23.714 37.867a13.85 13.85 0 0 1-13.182-9.51l-7.909 6.038a23.43 23.43 0 0 0 21.09 13.072c5.732 0 11.205-2.036 15.312-5.849l-7.507-5.804c-2.118 1.335-4.786 2.053-7.804 2.053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M46.145 24c0-1.387-.213-2.88-.534-4.267H23.714V28.8h12.604c-.63 3.091-2.346 5.468-4.8 7.014l7.507 5.804c4.314-4.004 7.12-9.969 7.12-17.618"
  }))));
};
export default SvgGoogle;